import { Modal } from 'antd'
import React from 'react'

import '.././../style/modal.less'

class BasicModal extends React.Component {

  handleCancel () {
    this.props.hideModal()
  }

  render () {
    const {title, visible, content, width} = this.props.modal
    return (
      <Modal
        title={title}
        visible={visible}
        wrapClassName="vertical-center-modal"
        footer={null}
        onCancel={() => this.handleCancel()}
        width={width}
      >
        {content}
      </Modal>
    )
  }
}

export default BasicModal


// WEBPACK FOOTER //
// ./src/app/components/common/BasicModal.js